import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import Sidebar from "./Components/Sidebar";
import Header from "./Components/Header";
import { AuthProvider } from "./authContext";

const PrivateRoute = () => {
  const location = useLocation();
  const token = localStorage.getItem("token");
  const userType = localStorage.getItem("userType");

  const allowedRoutes = ["/", "/report", "/app-settings"];

  const isAuthorized = (route) => {
    return userType !== "U" || allowedRoutes.includes(route);
  };

  return token ? (
    <div id="page-top">
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <AuthProvider>
              <Header />
              {isAuthorized(location.pathname) ? (
                <Outlet />
              ) : (
                <Navigate to="/" />
              )}
            </AuthProvider>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <Navigate to="/login" />
  );
};

export default PrivateRoute;
